export const borderlessNumberFieldSx = {
  width: "80px",
  marginInline: "4px",
  backgroundColor: "white",
  "& .MuiFilledInput-root": {
    border: "solid 1px silver",
    borderRadius: "4px",
    backgroundColor: "transparent",
    boxShadow: "none",
  },
  "& .MuiFilledInput-root:before": { borderBottom: "none" },
  "& .MuiFilledInput-root:after": { borderBottom: "none" },
  "& .MuiFilledInput-root:hover:before": { borderBottom: "none" },
  "& .MuiFilledInput-input": {
    padding: "6px 8px",
    textAlign: "center",
    fontSize: "14px",
  },
}

export const getPendingAmount = part =>
  Math.max(Number(part?.totalPrice ?? 0) - Number(part?.invoicedAmount ?? 0), 0)

export const getCurrentInvoicing = (part, invoicingDrafts) => {
  const certificationId = part?.cert?.certification_id
  const draft = invoicingDrafts?.[certificationId]?.[part?.partidaId]?.invoicing

  if (draft !== undefined) {
    return Number(draft)
  }

  if (part?.invoiceAmountPending != null) {
    return Number(part.invoiceAmountPending)
  }

  return 0
}

export const getCurrentPercent = (part, currentInvoicing) => {
  const pendingAmount = getPendingAmount(part)

  return pendingAmount > 0 ? (currentInvoicing / pendingAmount) * 100 : 0
}

export const normalizeInvoicingAmount = (part, nextAmount) => {
  const pendingAmount = getPendingAmount(part)
  const normalizedAmount = Math.max(0, Number(nextAmount) || 0)

  return pendingAmount > 0 ? Math.min(normalizedAmount, pendingAmount) : 0
}

export const normalizeInvoicingPercent = (part, nextPercent) => {
  const pendingAmount = getPendingAmount(part)
  const normalizedPercent = Math.min(Math.max(Number(nextPercent) || 0, 0), 100)

  return pendingAmount > 0 ? (pendingAmount * normalizedPercent) / 100 : 0
}
